export const appVersion = '1.385.0-PORT-3201-UI-testing-SNAPSHOT-1793751303';
export const commitHash = '9c00b1d97';
